import React from 'react';

import styles from './CurrentDue.module.css';
import autopay_enabled from './autopay_enabled.svg';
import autopay_disabled from './autopay_disabled.svg';

const AutopayIcon = ({ enabled }) => (
  <div className={styles.autopay}>
    {
      enabled ?
        (
          <React.Fragment>
            <img src={autopay_enabled} alt="" />
            Auto payment is on
          </React.Fragment>
        ) : (
          <React.Fragment>
            <img src={autopay_disabled} alt="" />
            Auto payment is off
          </React.Fragment>
        )
    }
  </div>
);

export default AutopayIcon;
